import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {PlinkoBucketConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoBucketConfig";
import {PlinkoObstacleConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoObstacleConfig";
import {PlinkoPhysicsConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoPhysicConfig";


export class PlinkoStageConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(PlinkoStageConfig, v) : SKIP;
        }, (v) => {
            return deserialize(PlinkoStageConfig, v);
        });
    }

    constructor() {
        super();

        this._key = null;
        this._points = 0;
        this._physicsConfig = null;

        this._buckets = [];
        this._obstacles = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get points() {
        return this._points;
    }

    set points(value) {
        this._points = value;
    }

    get physicsConfig() {
        return this._physicsConfig;
    }

    set physicsConfig(value) {
        this._physicsConfig = value;
    }

    get buckets() {
        return this._buckets;
    }

    set buckets(value) {
        this._buckets = value;
    }

    get obstacles() {
        return this._obstacles;
    }

    set obstacles(value) {
        this._obstacles = value;
    }

    valid() {

        if (!this.key || this.key.length === 0) {
            return false;
        }

        if (!Number.isInteger(this.points) || this.points < 0) {
            return false;
        }

        if (this.physicsConfig && !this.physicsConfig.valid()) {
            return false;
        }

        if (!this.buckets || this.buckets.length === 0) {
            return false;
        }

        if (this.buckets.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.obstacles || this.obstacles.length === 0) {
            return false;
        }

        if (this.obstacles.some(v => !v || !v.valid())) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.buckets || this.buckets.length === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PlinkoStageConfig());
        } else if (target instanceof PlinkoStageConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PlinkoStageConfig, {
    _key: alias("key", Schema.primitive()),
    _points: alias("points", Schema.primitive()),
    _physicsConfig: alias("physics_config", PlinkoPhysicsConfig.schema()),

    _buckets: alias("buckets", list(PlinkoBucketConfig.schema())),
    _obstacles: alias("obstacles", list(PlinkoObstacleConfig.schema()))
});